import { Component, Input, ChangeDetectionStrategy, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService } from '@app/layout/services/theme.service';
import { DefaultTheme, Theme } from '@app/models';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-theme-toggle',
  standalone: true,
  imports: [CommonModule],
  template: `
    <button
      class="theme-toggle"
      [class.theme-toggle--dark]="isDarkTheme"
      (click)="toggleTheme()"
      type="button"
      aria-label="Toggle theme">
      <span class="theme-toggle__track">
        <span class="theme-toggle__icon icon-sun-shine"></span>
        <span class="theme-toggle__icon icon-moon"></span>
        <span class="theme-toggle__handle"></span>
      </span>
    </button>
  `,
  styleUrls: ['./theme-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeToggleComponent implements OnInit, OnDestroy {
  @Input() lightTheme: string = DefaultTheme.LIGHT;
  @Input() darkTheme: string = DefaultTheme.DARK;

  currentTheme: Theme = DefaultTheme.LIGHT;
  private destroy$ = new Subject<void>();

  constructor(private themeService: ThemeService) {}

  ngOnInit(): void {
    this.themeService.theme$
      .pipe(takeUntil(this.destroy$))
      .subscribe((theme) => {
        this.currentTheme = theme;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get isDarkTheme(): boolean {
    return this.currentTheme === this.darkTheme;
  }

  toggleTheme(): void {
    const newTheme = this.isDarkTheme ? this.lightTheme : this.darkTheme;
    this.themeService.toggleTheme(newTheme as Theme);
  }
}
